// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { isString } from "@sequentech/ui-core";
import { setBallotStyle } from "../store/ballotStyles/ballotStylesSlice";
import { resetBallotSelection } from "../store/ballotSelections/ballotSelectionsSlice";
import { checkIsExplicitBlankVote, checkIsInvalidVote } from "./ElectionConfigService";
import { getSlateConfigurationProblem } from "./Slates";
var BallotStyleConfigurationError = /** @class */ (function (_super) {
    __extends(BallotStyleConfigurationError, _super);
    function BallotStyleConfigurationError(translationKey, translationParams) {
        var _this = _super.call(this, translationKey) || this;
        _this.name = "BallotStyleConfigurationError";
        _this.translationKey = translationKey;
        _this.translationParams = translationParams;
        return _this;
    }
    return BallotStyleConfigurationError;
}(Error));
export { BallotStyleConfigurationError };
export var getBallotStyleConfigurationError = function (ballotStyle) {
    for (var _i = 0, _a = ballotStyle.contests; _i < _a.length; _i++) {
        var contest = _a[_i];
        var explicitInvalidCount = contest.candidates.filter(checkIsInvalidVote).length;
        if (explicitInvalidCount > 1) {
            return new BallotStyleConfigurationError("errors.configuration.multipleExplicitInvalidCandidates", { count: explicitInvalidCount });
        }
        var explicitBlankCount = contest.candidates.filter(checkIsExplicitBlankVote).length;
        if (explicitBlankCount > 1) {
            return new BallotStyleConfigurationError("errors.configuration.multipleExplicitBlankCandidates", { count: explicitBlankCount });
        }
    }
    var slateProblem = getSlateConfigurationProblem(ballotStyle);
    if (slateProblem !== undefined) {
        return new BallotStyleConfigurationError("errors.configuration.invalidSlateConfiguration", {
            reason: slateProblem,
        });
    }
    return undefined;
};
export var updateBallotStyleAndSelection = function (data, dispatch) {
    for (var _i = 0, _a = data.sequent_backend_ballot_style; _i < _a.length; _i++) {
        var ballotStyle = _a[_i];
        var ballotEml = ballotStyle.ballot_eml;
        if (!isString(ballotEml)) {
            continue;
        }
        try {
            var electionData = JSON.parse(ballotEml);
            var configurationError = getBallotStyleConfigurationError(electionData);
            if (configurationError) {
                throw configurationError;
            }
            var formattedBallotStyle = {
                id: ballotStyle.id,
                election_id: ballotStyle.election_id,
                election_event_id: ballotStyle.election_event_id,
                tenant_id: ballotStyle.tenant_id,
                ballot_eml: electionData,
                ballot_signature: ballotStyle.ballot_signature,
                created_at: ballotStyle.created_at,
                area_id: ballotStyle.area_id,
                annotations: ballotStyle.annotations,
                labels: ballotStyle.labels,
                last_updated_at: ballotStyle.last_updated_at,
            };
            dispatch(setBallotStyle(formattedBallotStyle));
            dispatch(resetBallotSelection({
                ballotStyle: formattedBallotStyle,
                force: true,
            }));
        }
        catch (error) {
            console.log("Error loading EML: ".concat(error));
            console.log(ballotEml);
            throw error;
        }
    }
};
